var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item", class: _vm.itemCssClass }, [
    _c("div", { staticClass: "title" }, [
      _c("h3", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "value" }, [_vm._v(_vm._s(_vm.content))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }